# MAGIC_DESPROCKET_START
#   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
#
#   For details and info on using this file see the wiki:
#     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
#
#   STATUS: auto generated
#   LOADERS: sprocket-compat?this!
#   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
# MAGIC_DESPROCKET_END
value = 0

window.GlobalIncrementor =
  next: -> ++value

export default GlobalIncrementor
